export enum ProposalTypes {
  NewBusinessProposal = 'NewBusinessProposal',
  RenewalProposal = 'RenewalProposal',
}

export const leftBarWidth = 47;
